import React from "react"
import UMRLogo from "../assets/icons/umr/Uni-Marburg-Philipp-Sonder-weiss-RGB.svg"

const Umr: React.FC<{ className: string }> = ({ className }) => (
  <a href="https://www.uni-marburg.de/" class="">
    <span>
      <UMRLogo class={className} />
    </span>
  </a>
)

export default Umr
